import { render } from "./YandexMetrikaScript.vue?vue&type=template&id=01988d22"
import script from "./YandexMetrikaScript.vue?vue&type=script&lang=js"
export * from "./YandexMetrikaScript.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__